import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";
import { Link } from "gatsby";
import {
  BsFillPersonCheckFill,
  BsFillQuestionDiamondFill,
} from "react-icons/bs";
import { GiReceiveMoney } from "react-icons/gi";
import { FaShippingFast, FaMapMarkerAlt } from "react-icons/fa";
import { AiOutlineMail, AiFillPhone } from "react-icons/ai";
import {
  FiInstagram,
  FiFacebook,
  FiYoutube,
  FiTwitter,
  FiLinkedin,
} from "react-icons/fi";

import MainFeature from "../components/MainFeature";

const Index = () => {
  const recQuery = useStaticQuery(graphql`
    query {
      allFile(filter: { relativeDirectory: { eq: "recomendado" } }) {
        edges {
          node {
            relativeDirectory
            childImageSharp {
              fixed(width: 250, height: 250) {
                ...GatsbyImageSharpFixed_withWebp_tracedSVG
              }
            }
          }
        }
      }
    }
  `);

  const [imgState, setImg] = useState(0);

  useEffect(() => {
    let i = imgState;
    let length = recQuery.allFile.edges.length - 1;
    setImg(i);
    setInterval(() => {
      if (i === length) {
        i = 0;
      } else {
        i++;
      }
      setImg(i);
    }, 5000);
  }, [recQuery, imgState]);

  return (
    <Layout>
      <SEO></SEO>
      <MainFeature></MainFeature>

      <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
        Distribuidora Ekobé Indaiatuba
      </h2>
      <div className="flex flex-wrap mt-2 h-64 container mx-auto ">
        <div className=" transition duration-500 ease-in-out hover:bg-green-400 transform hover:-translate-y-1 hover:scale-y-110 shadow-lg text-center bg-green-100 w-1/2 md:w-1/4 flex flex-col justify-center items-center">
          <BsFillPersonCheckFill className="text-4xl text-teal-600"></BsFillPersonCheckFill>
          <h3 className="font-bold mt-2 text-gray-800 text-lg">
            Atendimento Personalizado
          </h3>
        </div>
        <div className=" transition duration-500 ease-in-out hover:bg-green-400 transform hover:-translate-y-1 hover:scale-y-110 shadow-lg text-center bg-green-100 w-1/2 md:w-1/4 flex flex-col justify-center items-center">
          <BsFillQuestionDiamondFill className="text-4xl text-teal-600"></BsFillQuestionDiamondFill>
          <h3 className="font-bold mt-2 text-gray-800 text-lg">
            Tire Dúvidas por WhatsApp
          </h3>
        </div>
        <div className=" transition duration-500 ease-in-out hover:bg-green-400 transform hover:-translate-y-1 hover:scale-y-110 shadow-lg text-center bg-green-100 w-1/2 md:w-1/4 flex flex-col justify-center items-center">
          <GiReceiveMoney className="text-4xl text-teal-600"></GiReceiveMoney>
          <h3 className="font-bold mt-2 text-gray-800 text-lg">
            Melhor Custo Benefício
          </h3>
        </div>
        <div className=" transition duration-500 ease-in-out hover:bg-green-400 transform hover:-translate-y-1 hover:scale-y-110 shadow-lg text-center bg-green-100 w-1/2 md:w-1/4 flex flex-col justify-center items-center">
          <FaShippingFast className="text-4xl text-teal-600"></FaShippingFast>
          <h3 className="font-bold mt-2 text-gray-800 text-lg">
            Entrega Rápida
          </h3>
        </div>
      </div>

      <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
        Conheça Quem Recomenda EKOBÉ
      </h2>

      <div className="mt-2 container mx-auto text-center">
        {recQuery.allFile.edges.map((edge, index) => (
          <Link to="/produtos" key={index}>
            <Img
              className="rounded-full shadow-lg mx-4"
              objectPosition="top left"
              fixed={edge.node.childImageSharp.fixed}
              alt="Recomenda"
            />
          </Link>
        ))}
      </div>

      <div className="bg-teal-400 h-6 mt-2"></div>
      <div className="bg-teal-500 ">
        <div className="container mx-auto px-1 py-4 flex flex-wrap items-center justify-center">
          <div className="text-center w-full md:w-1/2 flex flex-col justify-center items-center">
            <h3 className="font-bold text-white text-2xl mb-4">Informações</h3>
            <div className="text-lg text-left">
              <div>
                <FaMapMarkerAlt className="inline  text-white"></FaMapMarkerAlt>
                <h3 className="ml-2 inline mt-2 text-white ">
                  Rua Zephiro Puccinelli, 593 - Indaiatuba/SP
                </h3>
              </div>
              <div>
                <AiFillPhone className="inline  text-white"></AiFillPhone>

                <h3 className="ml-2 inline mt-2 text-white ">
                  (19) 99382-0824
                </h3>
              </div>

              <div>
                <AiOutlineMail className="inline  text-white"></AiOutlineMail>
                <h3 className="ml-2 inline mt-2 text-white ">
                  contato@ekobeindaiatuba.com.br
                </h3>
              </div>
            </div>
          </div>
          <div className="text-center w-full md:w-1/2 flex flex-col justify-center items-center">
            <h3 className="font-bold mt-2 text-white text-2xl mb-4">
              Conheça Nosso Trabalho
            </h3>
            <div className="flex text-white text-4xl">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://facebook.com/EkobeOficial"
              >
                <FiFacebook className="mr-4"></FiFacebook>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://instagram.com/EkobeOficial"
              >
                <FiInstagram className="mr-4"></FiInstagram>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://linkedin.com/company/EkobeOficial"
              >
                <FiLinkedin className="mr-4"></FiLinkedin>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://twitter.com/EkobeOficial"
              >
                <FiTwitter className="mr-4"></FiTwitter>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.youtube.com/EkobeOficial"
              >
                <FiYoutube className="mr-4"></FiYoutube>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mt-2 h-96 transition duration-500 ease-in-out bg-blue-500 hover:bg-red-500 transform hover:-translate-y-1 hover:scale-y-110"></div> */}
    </Layout>
  );
};

export default Index;
